const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "https://app.dijkgraaf-support.nl/v1";

const config = {
  apiBaseUrlV1: apiBaseUrl,
  apiBaseUrlV2: apiBaseUrl.replace(/\/v1$/, "/v2"),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "https://0e109ce909dba342a028b04e8da7404e@sentry.ventumsoftware.nl/40",
  enableDebugMode: import.meta.env.VITE_ENABLE_DEBUG_MODE
    ? import.meta.env.VITE_ENABLE_DEBUG_MODE !== "false"
    : import.meta.env.MODE === "development",
  openIdRealm: import.meta.env.VITE_OPENID_REALM ?? "dijkgraaf",
  openIdClient: import.meta.env.VITE_OPENID_CLIENT ?? "dijkgraaf",
};
export default config;
